import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { useInsertCartItemByIdMutation } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import {
  cartState,
  guestCheckoutDataState,
  isCartUpdatingState,
  orderCalculationState
} from "src/states";

export const useAddCartFromGuest = () => {
  const guestCheckoutData = useRecoilValue(guestCheckoutDataState);
  const setIsUpdating = useSetRecoilState(isCartUpdatingState);
  const setCart = useSetRecoilState(cartState);
  const setOrderCalculation = useSetRecoilState(orderCalculationState);

  const { mutateAsync: insertCartItemByIdAsync } = useInsertCartItemByIdMutation(graphQLClient);

  useEffect(() => {
    (async () => {
      if (guestCheckoutData) {
        const { priceId, productId } = guestCheckoutData;
        setIsUpdating(true);

        const data = await insertCartItemByIdAsync({
          input: {
            //   id: cart.id,
            productId,
            selectedPriceId: priceId,
            shouldReturnCalculation: true,
            fbc: localStorage.fbc,
            fbp: localStorage.fbp
          }
        });

        const result = data?.insertCartItemById;

        if (result) {
          setCart(result);
          setOrderCalculation(result.calculation);
        }
        setIsUpdating(false);
      }
    })();
  }, [guestCheckoutData, insertCartItemByIdAsync, setCart, setIsUpdating, setOrderCalculation]);
};
